export const version = '2.17.3';
//# sourceMappingURL=version.js.map